export default "__VITE_ASSET__DkMh8Q_p__"